module.exports = __webpack_public_path__ + "static/media/ic_sidemenu_calculations.6f723534.svg";